import Slick from 'vue-slick';

export default Slick;
